import { type Dispatch } from 'redux';
import { type PayloadAction, createAction } from 'typesafe-actions';

import ViewActions from '../constants/ViewActions';

import { notifyCriticalRenderPath } from './Application';

/**
 * Action creator triggered by any interactions on the Now Playing component
 *
 */

type ToggleTprTextParams = $TSFixMe;

interface ToggleTprTextPayload {
  isFaded: ToggleTprTextParams;
}

export const toggleTprText = createAction(
  ViewActions.TOGGLE_TPR_TEXT,
  (isFaded: ToggleTprTextParams) => ({ isFaded }),
)<ToggleTprTextPayload>();
export type ToggleTprTextAction = ReturnType<typeof toggleTprText>;

export const openNowPlaying = createAction(ViewActions.OPEN_NOW_PLAYING)();
export type OpenNowPlayingAction = ReturnType<typeof openNowPlaying>;

export const closeNowPlaying = createAction(ViewActions.CLOSE_NOW_PLAYING)();
export type CloseNowPlayingAction = ReturnType<typeof closeNowPlaying>;

type OpenSessionHistoryParams = $TSFixMe;

interface OpenSessionHistoryPayload {
  historySize: OpenSessionHistoryParams;
}

export const openSessionHistory = createAction(
  ViewActions.OPEN_SESSION_HISTORY,
  (historySize: OpenSessionHistoryParams) => ({ historySize }),
)<OpenSessionHistoryPayload>();
export type OpenSessionHistoryAction = ReturnType<typeof openSessionHistory>;

interface CloseSessionHistoryParams {
  isLeavingNowPlaying: boolean;
}

export const closeSessionHistory = createAction(
  ViewActions.CLOSE_SESSION_HISTORY,
  ({ isLeavingNowPlaying = false }: CloseSessionHistoryParams) => ({ isLeavingNowPlaying }),
)<CloseSessionHistoryParams>();
export type CloseSessionHistoryAction = ReturnType<typeof closeSessionHistory>;

export const hoveredOverStationList = createAction(ViewActions.HOVERED_OVER_STATION_LIST)();
export type HoveredOverStationListAction = ReturnType<typeof hoveredOverStationList>;

export const hoveredOutStationList = createAction(ViewActions.HOVERED_OUT_STATION_LIST)();
export type HoveredOutStationListAction = ReturnType<typeof hoveredOutStationList>;

export const clickedSearchBoxComponent = createAction(ViewActions.CLICKED_SEARCH_BOX_COMPONENT)();
export type ClickedSearchBoxComponentAction = ReturnType<typeof clickedSearchBoxComponent>;

type SetSessionHistoryIndexParams = $TSFixMe;
interface SetSessionHistoryIndexPayload {
  sessionHistoryIndex: SetSessionHistoryIndexParams;
}

export type SetSessionHistoryIndexAction = PayloadAction<
  typeof ViewActions.SET_SESSION_HISTORY_INDEX,
  SetSessionHistoryIndexPayload
>;
export const setSessionHistoryIndex =
  (sessionHistoryIndex: SetSessionHistoryIndexParams) =>
  (dispatch: Dispatch<SetSessionHistoryIndexAction | $TSFixMe>): SetSessionHistoryIndexAction => {
    dispatch(notifyCriticalRenderPath());
    return dispatch({
      type: ViewActions.SET_SESSION_HISTORY_INDEX,
      payload: {
        sessionHistoryIndex,
      },
    });
  };
